var _indexOf = require('./_indexOf');


module.exports = function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
};



//////////////////
// WEBPACK FOOTER
// /home/deploy/7n_production/shared/~/ramda/src/internal/_contains.js
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7